import { render, staticRenderFns } from "./VaRadioContentCard.vue?vue&type=template&id=36909021&scoped=true&"
import script from "./VaRadioContentCard.vue?vue&type=script&lang=js&"
export * from "./VaRadioContentCard.vue?vue&type=script&lang=js&"
import style0 from "./VaRadioContentCard.vue?vue&type=style&index=0&id=36909021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36909021",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
